/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Translation file for Dutch language
 *
 * @file nl.js
 * @author Manimaran.S
 */

const nl = {
  'popularChannelSlider.allChannels': 'Alle Channels',
  'popularChannelSlider.recommended': 'Aanbevolen',
  'hero.myetextbook.link': 'met eTextbooks',
  'hero.myetextbook.text': 'Niet de juiste titel? Neem een kijkje in uw bibliotheek',
  'hero.etextfeaturestitle': 'Vind studiematerialen in uw eTextbook',
  'hero.etextfeaturesdescription': 'Bij uw eTextbook krijgt u speciaal voor u opgesteld studiemateriaal. Studeer met flashcards en nog veel meer, direct in uw eTextbook.',
  'aichat.title1': 'Krijg hulp op basis van AI over alles wat in dit eTextbook aan bod komt',
  'aichat.chatDesc1': 'Typ een vraag om te beginnen',
  'subscriptiontext.isSubscribed': 'Onderdeel van uw abonnement',
  'subscriptiontext.nonSubscriber': 'Upgrade uw abonnement voor volledige toegang',
  'topicConatiner.otherHeader': '.',
  'topicConatiner.exactLiteHeader': '.',
  'moremenu.downloadApp': '.',
  'moremenu.downloadAppAlreadyDownload': '%Click here% om de app te downloaden op een ander apparaat en automatisch in te loggen of om uw unieke QR-code te gebruiken om veilig op de app in te loggen als u die al geïnstalleerd hebt.',
  'moremenu.downloadAppNotDownload': '%Click here% om de app te downloaden veilig in te loggen met uw unieke QR-code.',
  'channel.noBundletitle': 'Gebruik Studievoorbereiding voor uw gerelateerde en andere cursussen',
  'onboard.studyPlan': 'Aangepast studieplan aangemaakt!',
  'onboard.addCourseAnother': 'Wilt u een andere cursus toevoegen?',
  'onboard.purchase': 'Ik wil een eTextbook van Pearson kopen',
  'onboard.addCourseWithoutEtext': 'Voeg een cursus toe met Studievoorbereiding',
  'onboard.mayBeLater': 'Misschien later',
  'onboard.aboutCourse': 'Vertel ons meer over uw cursus',
  'onboard.close': 'Sluiten',
  'course.addTitle': 'Cursus toevoegen',
  'common.PURCHASE': 'Kopen',
  'common.CLOSE': 'Sluiten',
  'open': 'openen',
  'continue': 'Doorgaan',
  'yes': 'Ja',
  'no': 'Nee',
  'audio': 'Audio',
  'courses.toc.PUBLISH_SUCCESS': 'Veel succes!',
  'courses.toc.PUBLISH_MESSAGE': 'Deelnemers zien uw wijzigingen de volgende keer als ze de inhoud bekijken.',
  'errors.GENERIC_TITLE': '.',
  'errors.GENERIC_DESC': '.',
  'errors.GENERIC_LINK': '.',
  'errors.GENERIC_CODE': '.',
  'errors.SUBSCRIPTION_GENERIC_TITLE': 'Abonnement niet gevonden',
  'errors.SUBSCRIPTION_GENERIC_DESC': 'Uw account bevat geen toegang tot deze titel. Als u denkt dat u dit bericht niet had moeten ontvangen, neem dan contact op met Pearson Technical Support',
  'errors.SUBSCRIPTION_REGISTRATION_TITLE': 'Abonnement niet gevonden',
  'errors.SUBSCRIPTION_REGISTRATION_DESC': 'Uw abonnement bevat geen toegang tot de eText, maar u kunt zich hiervoor wel aanmelden met een creditcard',
  'link.ACCESSIBILITY': 'https://www.pearson.com/us/accessibility.html',
  'link.PRIVACY': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonPrivacyPolicy.html',
  'link.SUPPORT': 'https://support.pearson.com/getsupport/s/?_ga=2.116082310.1845539610.1557867919-NimtqV7BcT00BM9xOXCQUFJYwF3RzEIk',
  'link.TOSURL': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonEULA.html',
  'link.FAQS_NONMOJO': '',
  'link.TERMS_OF_USE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/terms-of-use.html',
  'link.PRIVACY_NOTICE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/privacy-policy.html',
  'link.ACCESSIBILITY_SUPPORT_NONMOJO': '',
  'menu.myAccount': 'Mijn account',
  'menu.helpCenter': 'Helpcentrum',
  'menu.preferencesCenter': 'Voorkeurenoverzicht',
  'menu.CONTACT_SUPPORT': 'Contact opnemen met Ondersteuning',
  'menu.HELP_SUPPORT': 'Help & ondersteuning',
  'menu.FAQS': 'Veelgestelde vragen',
  'menu.CHAT_WITH_SUPPORT': 'Chat met Ondersteuning',
  'menu.OTP_CODES': 'OTP-codes',
  'menu.LAUNCH_CODE': 'Code log lanceren',
  'menu.SEND_CODE': 'Stuur gebruiker een nieuwe code via e-mail',
  'menu.SEND_CODE_PHONE': 'Stuur gebruiker een nieuwe code via een tekstbericht',
  'menu.LEGAL': 'Wettelijk',
  'menu.PRIVACY_NOTICE': 'Privacyverklaring',
  'menu.TITLE_INFO': 'Titelgegevens',
  'menu.PEARSON_ACCESSIBILITY': 'Toegankelijkheid Pearson',
  'menu.DEVICE_WARNING_MESSAGE': 'Registreer {deviceLimit} apparaten. Switch één keer per maand.',
  'menu.ACCESSIBILITY': 'Toegankelijkheid',
  'menu.ACCESSIBILITY_SUPPORT': 'Toegankelijkheidsondersteuning',
  'menu.DEVICES': 'Onlangs gebruikte apparaten',
  'menu.THIS_DEVICE': 'Dit apparaat',
  'menu.GET_THE_APP_DOWNLOAD': 'Download de mobiele app',
  'menu.MOJO_APP_INFO': 'Ga naar de app store op je telefoon of tablet om Pearson+ offline te gebruiken.',
  'menu.DEVICE_LABEL': 'Apparaat',
  'menu.DEVICE_DISCONNECT': 'Loskoppelen',
  'menu.FOXIT': 'Ondersteund door Foxit',
  'menu.TERMS_OF_USE': 'Gebruiksvoorwaarden',
  'menu.SIGN_OUT': 'Uitloggen',
  'menu.PRINT_PAGE': 'Pagina afdrukken',
  'menu.COPY_RIGHT': 'Copyright © {year} Pearson Education, Inc. Alle rechten voorbehouden.',
  'print.FOOTER_MESSAGE': 'Gedrukt door {fullName}({email}) op {currentDate}.',
  'print.WATERMARK': '.',
  'device.SWAPPED_ALREADY': 'U heeft deze maand al geruild',
  'device.SWITCH_DEVICE': 'Overschakelen naar huidig apparaat?',
  'device.SWITCH_ONCE': 'Aangezien u maar één keer per maand kunt overstappen, kunt u dit niet ongedaan maken.',
  'device.SEAT_TAKEN': 'Die plek is bezet',
  'device.DISCONNECT_DEVICE': 'U kunt maar op 3 apparaten inloggen. Koppel een ander apparaat los om hier verder te gaan.',
  'device.ALERT_TEXT': 'Onthoud, u kunt slechts één keer per maand tussen apparaten switchen.',
  'device.DISCONNECT': 'Loskoppelen',
  'device.CONTINUE': 'Doorgaan',
  'device.HEADER': 'Uw browsersessie beëindigen?',
  'device.CLOSE': 'Terug naar Startpagina',
  'device.CODE': '.',
  'device.TIMER': 'U moet {time} uw code hier invoeren',
  'device.RESEND': '.',
  'device.FAQ': '.',
  'device.RESEND_NAME': 'Opnieuw versturen',
  'device.NOTE': '.',
  'device.NOTE_HEADER': '.',
  'device.CONTACT_SUPPORT': 'Klantondersteuning',
  'device.CONTACT_EMAIL': 'update uw e-mailadres',
  'device.INCORRECT': 'Onjuist. Controleer uw code of verstuur deze opnieuw.',
  'device.MANY_ATTEMPTS': 'Teveel pogingen. Vraag een nieuwe code op',
  'device.EXPIRED': 'Dit duurde te lang. Vraag een nieuwe code op',
  'device.ACCESS_HEADER': 'U bent binnen!',
  'device.ACCESS_DESC': 'Uw sessie is geverifieerd. Wilt u uw wachtwoord nu bijwerken?',
  'device.ACCESS_CHANGE_PASSWORD': 'Wachtwoord wijzigen',
  'device.ACCESS_RESET_PASSWORD': 'Wachtwoord opnieuw instellen',
  'device.THREATONE_TITLE': 'Ziet alles er goed uit?',
  'device.THREATONE_DESC': 'We hebben verdachte activiteiten op uw account waargenomen.',
  'device.THREATONE_DESC_TWO': 'We raden u aan uw wachtwoord te wijzigen.',
  'device.MAY_BE_LATER': 'Misschien later',
  'device.OKAY': 'OK',
  'device.ACCOUNT_LOCK_DESC': 'Om het te beveiligen, loggen we u uit en hebben we u een link gestuurd waarmee u uw wachtwoord dat bij het e-mailadres waarmee uw account geregistreerd is, opnieuw kunt instellen.',
  'device.ACCOUNT_LOCK_TITLE': 'We hebben verdachte activiteiten op uw account waargenomen',
  'device.ACCOUNT_LOCK_TIMER': 'U wordt uitgelogd {time}',
  'navigation.PAGE': 'Pagina',
  'launchcode.CREATEBY': 'Aangemaakt door:',
  'launchcode.sentvia': 'Verstuurd via:',
  'launchcode.CODEINLAST': 'Codes in de afgelopen 7 dagen:',
  'launchcode.TIMESENT': 'Tijd verstuurd:',
  'launchcode.ACCOUNTEMAIL': 'E-mailadres van account:',
  'launchcode.LAUNCHDIALOGTITLE': 'OTP-Code log',
  'textmessage.TITLE': 'Voer telefoonnummer in',
  'textmessage.PHONE_NUMBER': 'Telefoonnummer',
  'textmessage.SEND_CODE': 'Stuur code',
  'textmessage.INVALID_NUMBER': 'Ongeldig telefoonnummer.',
  'textmessage.SUCCESS_MESSAGE': 'Code verstuurd',
  'remove.title': 'Titel verwijderen?',
  'remove.subTitle': 'U kunt deze altijd later weer toevoegen door middel van de zoekfunctie.',
  'remove.buttonText': 'Verwijderen',
  'search.searchPlaceHolderPPlus': 'Zoeken op ISBN, titel of auteur',
  'search.searchPlaceHolderEText': 'Uw bibliotheek doorzoeken',
  'footer.downloadMobileApp': 'Download de mobiele app',
  'footer.termsOfUse': 'Gebruiksvoorwaarden',
  'footer.privacy': 'Privacy',
  'footer.cookies': 'Cookies',
  'footer.doNotSellMyPersonalInformation': 'Verkoop mijn persoonsgegevens niet',
  'footer.accessibility': 'Toegankelijkheid',
  'footer.patentNotice': 'Patiëntverklaring',
  'footer.copyrights': 'Pearson Alle rechten voorbehouden.',
  'hero.toc.defaultPlacehoder': '.',
  'hero.openEtextBookV1': 'eTextbook openen',
  'hero.heroHeading': 'Omdat u in <span>{channel_title}</span> studeert',
  'hero.heroHeadingForBundleUser': 'Studievoorbereiding',
  'hero.study.help': 'Hulp krijgen bij het studeren',
  'hero.study.jumpBackIn': 'Kom terug',
  'hero.study.numOfUsers': 'Op dit moment gebruiken <b>{num_of_users}</b>  cursisten Channels.',
  'hero.heroChannel.cardsHeading': 'Doorgaan waar u gebleven bent',
  'hero.marketingcard1.copy.title': 'Leren met video\'s',
  'hero.marketingcard1.copy.description': 'Bekijk hapklare video\'s met uitleg over lastige onderwerpen.',
  'hero.marketingcard2.copy.title': 'Praktijkoefeningen',
  'hero.marketingcard2.copy.description': 'Bereid uw examen voor met duizenden oefenvragen en uitlegvideo\'s.',
  'hero.marketingcard3.copy.title': 'Hulp van ervaringsdeskundigen',
  'hero.marketingcard3.copy.description': 'Onze deskundigen beantwoorden al uw vragen.',
  'hero.popularTopics.heading': 'Andere populaire onderwerpen in dit Channel',
  'hero.popularChannels.headingv1': 'Volgt u een andere cursus?',
  'hero.popularChannels.descriptionv2': 'Blader door populaire studieonderwerpen.',
  'hero.practice': 'Oefenen',
  'hero.herobook.mappedChannelHeading': 'Kanaal met aanbevolen hulp bij studeren',
  'libraryL2.myBooks': '.',
  'libraryL2.archived': 'Gearchiveerd',
  'libraryL2.back': 'Terug',
  'hero.practiceProblem': '.',
  'nativeAppBanner.drawer.title': '.',
  'nativeAppBanner.drawer.pearsonApp': '.',
  'nativeAppBanner.banner.title': '.',
  'nativeAppBanner.banner.description': '.',
  'hero.promotionalcard.list1': 'Hapklare video\'s met uitleg over lastige onderwerpen',
  'hero.promotionalcard.list2': 'Duizenden oefenvragen',
  'hero.promotionalcard.list3': 'Onze deskundigen beantwoorden al uw vragen',
  'hero.studyandexamprep': 'Studievoorbereiding',
  'hero.heroBook.sectionSubHeadingV1': 'Verslind diverse onderwerpen met video-uitleg, oefenvragen en uitleg in video\'s, speciaal voor uw cursus.',
  'hero.heroBook.sectionSubHeadingV2': 'Verslind diverse onderwerpen met uitleg over begrippen, oefenvragen en uitleg in video\'s, speciaal voor uw cursus.',
  'hero.SeeAllStudyOptions': '.',
  'hero.herobook.mappedChannelHeadingV1': '.',
  'hero.popularTopics.headingV1': 'Andere populaire onderwerpen',
  'hero.heroHeadingV1': '.',
  'hero.learnmore': 'Meer informatie',
  'hero.eTextbook': 'eTextbook',
  'hero.goToPage.label': 'Ga naar pagina',
  'subscription.studyTitle': 'Studievoorbereiding',
  'print.printAvailTitle': 'Wilt u deze pagina uitprinten? Zo doet u dat',
  'print.printAvailDesc': 'Selecteer in uw eTextbook het accountpictogram rechts bovenin. In de opties kiest u "Pagina afdrukken" en selecteert u uw gewenste printinstellingen.',
  'print.printNotAvailTitle': '.',
  'print.printNotAvailDesc': '.',
  'hero.header.cta': '.',
  'hero.header.ctav2': 'Studievoorbereiding openen',
  'hero.marketing.title': 'Vind uw eTextbook hier',
  'hero.marketing.subTitle': 'Kies uit meer dan 2000 eTextbooks met audio, flashcards, notities, video\'s van experts en nog veel meer. Vier maanden voor slechts $ 10,99 per maand.',
  'hero.popularchannels.desc': 'Hulp bij studeren met deze populaire onderwerpen.',
  'hero.removecourse.title': 'Cursus verwijderen van dashboard?',
  'hero.removecourse.description': 'U kunt deze cursus weer terugzetten op uw dashboard via "Cursus toevoegen"',
  'hero.removecourse.primaryCtaText': 'Verwijderen',
  'hero.removecourse.secondaryCtaText': 'ANNULEREN',
  'hero.tableOfContents': 'Inhoudsopgave',
  'hero.search': 'Zoeken',
  'hero.emptystate.cta': 'eTextbooks zoeken',
  'hero.watch_it_again': 'Opnieuw bekijken',
  'hero.mondly.learnLang.title': 'Gratis een nieuwe taal leren',
  'hero.mondly.subTitle': 'Gebruikers van Pearson eTextbook krijgen van Pearson drie maanden gratis toegang tot Mondly.',
  'hero.mondly.description': 'Bij de meeste apps leert u een vreemde taal vanuit het Engels. Het is natuurlijk veel handiger als u vanuit uw eigen taal kunt leren. Bij Mondly kunt u kiezen uit 41 talen.',
  'hero.mondly.startLearningCTA': 'Beginnen met leren',
  'hero.mondly.marketing.bestApp': '.',
  'hero.mondly.marketing.appStore': 'App Store',
  'hero.mondly.marketing.appYear': '.',
  'hero.mondly.marketing.fbStart': '.',
  'hero.mondly.marketing.editorChoice': '.',
  'hero.mondly.marketing.googlePlay': 'Google Play',
  'header.menu.learnLanguage': 'Een taal leren',
  'header.menu.moreAtPearson': 'Meer van Pearson',
  'hero.subscriptionStatusTitle2': 'Uw middelen van Pearson+',
  'hero.startStudying': 'Begin met studeren',
  'onboard.studyMaterials': 'Kies uw vak en wij maken een dashboard met studiematerialen die op uw behoeften zijn afgestemd.',
  'hero.myETextbooks': 'Mijn eTextbooks',
  'header.continueInTheApp': 'Doorgaan in de app',
  'hero.learnTxt': 'Studeren',
  'hero.examPrepTxt': 'Examenvoorbereiding',
  'hero.aITutorTxt': 'AI-begeleider',
  'AI.toolTip': 'Stel me een vraag over iets uit uw eTextbook',
  'hero.studyExamPrepAllYourCourses': 'Studievoorbereiding voor al uw cursussen',
  'header.qrCode.subHeaderTxt': 'Log via deze QR-code snel en veilig in op de Pearson+-app op uw mobiele toestel.',
  'header.qrCode.dontHaveApp': 'Hebt u de app niet?',
  'header.qrCode.footerTxt': 'Als u deze code scant, komt u direct in de App Store of Google Play terecht. Zodra u de app hebt gedownload, kunt u inloggen door de code nogmaals te scannen.',
  'header.qrCode.errorMsg': 'De QR-code is niet geladen. Sluit en probeer het nog eens.',
  'hero.yourETextbook': 'Uw eTextbook',
  'onboard.addCourseWithEtextBundle': 'Voeg een cursus toe met Studievoorbereiding',
  'onboard.disableTooltipText': 'Alle cursussen van Studievoorbereiding zijn toegevoegd!',
  'subscriptionstatus.bundlecta': 'Open Studievoorbereiding',
  'subscriptionstatus.nonbundlecta': 'Open Studievoorbereiding',
  'channel.genericBundle': 'Gebruik Studievoorbereiding voor uw andere cursussen',
  'channel.relatedBundle': 'Gebruik Studievoorbereiding ook voor uw andere cursussen',
  'onboard.courseAdded': 'Cursus toegevoegd!',
  'hero.flashcards': 'Flashcards',
  'relatedChannelCard.title': 'Leer nog effectiever met dit bijbehorende hulpmiddel',
  'relatedChannelCard.badgeText': 'Gerelateerd aan Studievoorbereiding',
  'sessionInactivity.title': 'Bent u er nog?',
  'sessionInactivity.description': '.',
  'sessionInactivity.keepMeSignIn': 'Houd mij ingelogd',
  'sessionInactivity.signOut': 'Uitloggen',
  'sessionTimeout.title': 'Sessie verlopen',
  'sessionTimeout.description': 'Uw sessie is verlopen, omdat u te lang niet actief bent geweest.',
  'print.qrCode.header': 'Open de Pearson+-app op uw mobiele toestel via deze QR-code.',
  'print.qrCode.footer': 'Als u deze code scant, komt u direct in de App Store of Google Play terecht. Zodra u de app hebt geïnstalleerd, logt u in om uw titel te lezen.',
  'hero.nestest.title': '.',
  'hero.nestest.subTitle': '.',
  'hero.channelAI.title': 'Hulp nodig? AI-begeleider staat voor u klaar.',
  'hero.channelAI.desc': 'Stel een vraag en krijg stapsgewijze hulp bij uw huiswerk, aanbevelingen en nog veel meer. Speciaal voor u en wanneer u maar wilt.',
  'hero.channelAI.action': 'Vraag het aan AI-begeleider',
  'new': 'Nieuw!',
  'hero.practice.numOfUsers': '.',
  'hero.practice.cta': '.',
  'hero.practice.title': '.',
  'diagnostics.errorMsg': 'Statistieken zijn niet geladen. Sluit en probeer het nog eens.',
  'qrcode.title': '.',
  'qrcode.subtitle': '.',
  'qrcode.detailsv1': '.',
  'qrcode.detailsv2': '.',
  'qrcode.details': '.',
  'qrcode.appstore': 'App Store',
  'qrcode.playstore': 'Google Play',
  'nativePromoBanner.description': '.',
  'install': 'Install',
  'header.menu.createCourse': 'Nieuwe cursus',
  'header.dropdown.courses': 'Cursussen',
  'header.dropdown.recentlyViewed': 'Onlangs bekeken',
  'header.dropdown.viewAll': 'Alle cursussen weergeven',
  'aet.courseHeader.inviteStudents': 'Studenten uitnodigen',
  'aet.courseHeader.inviteStudentModal.subTitle': 'Nodig studenten uit om dit eTextbook te raadplegen door de onderstaande link of instructies in uw e-mail of syllabus te kopiëren.',
  'aet.courseHeader.inviteStudentModal.linkAddress': 'Adres van de link',
  'aet.courseHeader.inviteStudentModal.copyLink': 'Link kopiëren',
  'aet.courseHeader.inviteStudentModal.instructionsTitle': 'Instructies met adres van de link',
  'aet.courseHeader.inviteStudentModal.copyInstructions': 'Instructies kopiëren',
  'aet.courseHeader.inviteStudentModal.instructionIntro': 'Het is tijd om {bookTitle} te raadplegen, het eTextbook voor {courseName}.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionAccessLink': 'Wanneer u klaar bent, kunt u uw eTextbook raadplegen op: {enrollmentLink}\n\n',
  'aet.courseHeader.inviteStudentModal.instructionSignIn': 'U krijgt de vraag om u aan te melden met uw bestaande Pearson-account. Als u geen Pearson-account hebt, kunt u een account aanmaken.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionHelp': 'Hulp nodig?',
  'aet.courseHeader.inviteStudentModal.instructionHelpLink': 'AskPearson',
  'aet.courseHeader.startDate': 'Begindatum:',
  'aet.courseHeader.endDate': 'Einddatum:',
  'aet.courseHeader.entitlement': 'Entitlement:',
  'aet.courseHeader.format': 'Indeling:',
  'aet.home.manageroster': 'Rooster beheren',
  'aet.home.managegradesync': 'Synchroniseren van resultaten beheren',
  'aet.home.copycourse': 'Cursus kopiëren',
  'aet.home.unlinkcourse': 'Unlink course',
  'aet.tempAccess.warningBannerMessage': 'Temporary access expires on {date}',
  'aet.tempAccess.alertBannerMessage': 'Temporary access ends in {days} days. Upgrade to avoid interruptions.',
  'aet.tempAccess.upgradeAccessLabel': 'Upgrade access',
  'aet.tempAccess.expiredTitle': 'Temporary access has expired',
  'aet.tempAccess.expiredWithActionDescription': 'Your progress has been saved. Upgrade your access now to continue where you left off.',
  'aet.tempAccess.manageRoster.bannerMessage': 'One or more students have temporary access that has expired or may expire before all assignments are due.',
  'aet.tempAccess.manageRoster.emailActionLabel': 'Get student emails and access instructions',
  'aet.tempAccess.manageRoster.email.title': 'Student emails and access instructions',
  'aet.tempAccess.manageRoster.email.subTitle': 'Help students maintain access to their eTextbook by sharing the following instructions',
  'aet.tempAccess.manageRoster.email.recipientsLabel': 'Affected student email addresses',
  'aet.tempAccess.manageRoster.email.instructionsLabel': 'Access instructions',
  'aet.tempAccess.manageRoster.email.greeting': 'Dear Student,',
  'aet.tempAccess.manageRoster.email.paragraph1': 'Your temporary access for {courseName} may no longer be active. To maintain access to your eTextbook and your reading assignments, upgrade your access as soon as possible.',
  'aet.tempAccess.manageRoster.email.paragraph2': 'Once you\'ve accessed your course, you should see a prompt to upgrade. If not, follow these steps:',
  'aet.tempAccess.manageRoster.email.bullet1': 'Go to my account by selecting the circle with your initials in the upper right',
  'aet.tempAccess.manageRoster.email.bullet2': 'Go to Manage subscription',
  'aet.tempAccess.manageRoster.email.bullet3': 'Look for your eTextbook and follow the prompts to upgrade your access',
  'aet.tempAccess.manageRoster.email.footerPrefix': 'You can find detailed directions for how to upgrade, including a video walkthrough here: ',

  'aet.instructorCourse.tabs.current': 'Huidige',
  'aet.instructorCourse.tabs.past': 'Verleden',
  'aet.instructorCourse.tabs.courseSettings': 'Instellingen cursus',
  'aet.instructorCourse.tabs.assignmentSettings': 'Assignment settings',
  'aet.instructorCourse.assignmentSettings.lmsAlertMessage': 'Important: Your LMS may also have assignment scoring settings. Changes in both places are applied together. To avoid unintended changes to final scoring, update settings in one place.',
  'aet.instructorCourse.assignmentSettings.gradebookSectionTitle': 'Display assignment scores in gradebook as',
  'aet.instructorCourse.assignmentSettings.gradebookInfoButtonAriaLabel': 'Learn about raw score and equal weighting',
  'aet.instructorCourse.assignmentSettings.rawScoreTitle': 'Raw score',
  'aet.instructorCourse.assignmentSettings.rawScoreDescription': 'Assignment scores vary based on the number of questions in each assignment.',
  'aet.instructorCourse.assignmentSettings.equalWeightingTitle': 'Equal weighting',
  'aet.instructorCourse.assignmentSettings.equalWeightingDescription': 'All assignments have the same base value.',
  'aet.instructorCourse.assignmentSettings.baseValueLabel': 'Base value:',
  'aet.instructorCourse.assignmentSettings.availabilitySectionTitle': 'Assignment availability',
  'aet.instructorCourse.assignmentSettings.availabilityFieldLabel': 'Assignments are available to students',
  'aet.instructorCourse.assignmentSettings.dueDatesSectionTitle': 'Scheduling defaults',
  'aet.instructorCourse.assignmentSettings.defaultDueTimeLabel': 'Default due time',
  'aet.instructorCourse.assignmentSettings.courseTimeZoneLabel': 'Course time zone',
  'aet.instructorCourse.assignmentSettings.cancelButtonLabel': 'Cancel',
  'aet.instructorCourse.assignmentSettings.saveButtonLabel': 'Save changes',
  'aet.instructorCourse.assignmentSettings.gradebookInfoModalTitle': 'Raw Score vs Equal Weighting',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreHeading': 'Raw Score:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreBody': 'Grades reflect total points earned out of total points possible across all assignments. Longer or higher-point assignments naturally impact the final grade more.',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingHeading': 'Equal Weighting:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingBody': 'Every assignment is normalized using a consistent base value so that each task contributes equally to the final grade, regardless of length or point total.',
  'aet.instructorCourse.assignmentSettings.baseValueRequired': 'Base value is required',
  'aet.instructorCourse.assignmentSettings.baseValueInvalid': 'Enter a value between 1 and 100',
  'aet.instructorCourse.assignmentSettings.availability.immediate': 'Immediately upon publish',
  'aet.instructorCourse.assignmentSettings.availability.fourWeeksBefore': '4 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.twoWeeksBefore': '2 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.oneWeekBefore': '1 week before due date',
  'aet.instructorCourse.tabs.manageRoster': 'Rooster beheren',
  'aet.instructorCourse.currentCourses.title': 'Huidige cursussen',
  'aet.instructorCourse.pastCourses.title': 'Cursussen zoeken',
  'aet.instructorCourse.createOrCopy.title': 'Een eTextbook-cursus van Pearson aanmaken of kopiëren',
  'aet.instructorCourse.createOrCopy.sectionTitle': 'Kopieer de cursus van een andere instructeur of maak een nieuwe aan',
  'aet.instructorCourse.createOrCopy.copyPanel.title': 'Kopieer de cursus van een andere instructeur',
  'aet.instructorCourse.createOrCopy.copyPanel.subtitle': 'Voer het cursusnummer in om op zoek te gaan naar de cursus die u wilt kopiëren.',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdLabel': 'Cursusnummer',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdPlaceholder': 'Cursusnummer invoeren',
  'aet.instructorCourse.createOrCopy.copyPanel.searchedForPrefix': 'U hebt gezocht naar',
  'aet.instructorCourse.createOrCopy.catalogPanel.title': 'Nieuwe cursus aanmaken vanuit de catalogus',
  'aet.instructorCourse.createOrCopy.catalogPanel.subtitle': 'Zoeken op titel, auteur, ISBN of trefwoorden per onderwerp.',
  'aet.instructorCourse.createOrCopy.catalogPanel.searchPlaceholder': 'Zoeken ...',
  'aet.instructorCourse.createOrCopy.showMoreLabel': 'Meer tonen',
  'aet.instructorCourse.createOrCopy.showLessLabel': 'Minder tonen',
  'aet.instructorCourse.cancel': 'ANNULEREN',
  'aet.instructorCourse.loading': 'Bezig met laden...',
  'aet.instructorCourse.courseForm.copyError': 'Your course cannot be copied because the title is no longer supported. Please contact your Pearson representative or customer support.',
  'aet.instructorCourse.courseForm.gradeSync': 'Resultaten synchroniseren',
  'aet.instructorCourse.courseForm.gradeSyncLinkLabel': 'Synchroniseren van resultaten beheren',
  'aet.instructorCourse.courseForm.courseNameLabel': 'Naam van de cursus',
  'aet.instructorCourse.courseForm.courseNamePlaceholder': 'Naamloos',
  'aet.instructorCourse.courseForm.sectionNameLabel': 'Naam van het onderdeel',
  'aet.instructorCourse.courseForm.sectionNamePlaceholder': 'Naamloos',
  'aet.instructorCourse.courseForm.institutionFieldLabel': 'Instelling',
  'aet.instructorCourse.courseForm.institutionSelectLabel': 'Select an Institution',
  'aet.instructorCourse.courseForm.institutionPlaceholder': 'Start typing your institution',
  'aet.instructorCourse.courseForm.institutionRequiredError': 'Instelling is vereist',
  'aet.instructorCourse.courseForm.institutionSearchError': 'Er is iets misgegaan. Probeer het opnieuw.',
  'aet.instructorCourse.courseForm.institutionNoResults': 'Geen resultaten gevonden',
  'aet.instructorCourse.courseForm.findAnotherInstitutionLabel': 'Find another institution',
  'aet.instructorCourse.courseForm.higherEducationSectionLabel': 'Higher Education:',
  'aet.instructorCourse.courseForm.k12InstitutionsSectionLabel': 'K12 Institutions:',
  'aet.instructorCourse.courseForm.k12InstitutionsDescription': 'Go to your My Courses dashboard to create courses for this type of institution',
  'aet.instructorCourse.courseForm.createK12CourseLabel': 'Create K-12 course',
  'aet.instructorCourse.courseForm.k12EmptyStateHeadline': 'Creating a K–12 course?',
  'aet.instructorCourse.courseForm.k12EmptyStateDescription': 'You\'ll have to create it outside Pearson+. After that\'s complete, you\'ll be able to manage it here.',
  'aet.instructorCourse.courseForm.startDateLabel': 'Begindatum cursus',
  'aet.instructorCourse.courseForm.endDateLabel': 'Einddatum cursus',
  'aet.instructorCourse.courseForm.datePlaceholder': 'dd/mm/jj',
  'aet.instructorCourse.courseForm.allowCopyLabel': 'Anderen toestaan om deze cursus te kopiëren',
  'aet.instructorCourse.courseForm.shareCodeLabel': 'Deel deze code met de instructeurs die deze cursus willen kopiëren',
  'aet.instructorCourse.courseForm.copyCodeLabel': 'Code kopiëren',
  'aet.instructorCourse.courseForm.optionalSuffix': '(optioneel)',
  'aet.instructorCourse.courseForm.formValidationLiveRegion': 'Er zijn validatiefouten voor dit formulier',
  'aet.instructorCourse.courseForm.submitContinue': 'Doorgaan',
  'aet.instructorCourse.courseForm.submitContinueLoading': 'Opslaan ...',
  'aet.instructorCourse.courseForm.submitError': 'We konden uw cursus niet aanmaken. Probeer het opnieuw.',
  'aet.instructorCourse.courseForm.submitEditError': 'We konden uw cursus niet opslaan. Probeer het opnieuw.',
  'aet.instructorCourse.courseForm.submitSaveChanges': 'Wijzigingen opslaan',
  'aet.instructorCourse.courseForm.materialsHeader': 'Cursusmaterialen',
  'aet.instructorCourse.courseForm.resolveError': 'We konden uw cursusmaterialen niet laden. Probeer het opnieuw.',
  'aet.instructorCourse.courseForm.copySourceError': 'We could not load the course to copy. Please search again from Create or copy course.',
  'aet.instructorCourse.coursesSort.lastViewed': 'Voor het laatst weergegeven',
  'aet.instructorCourse.coursesSort.recentlyAdded': 'Onlangs toegevoegd',
  'aet.instructorCourse.coursesSort.aToZ': 'A tot Z',
  'aet.instructorCourse.coursesSort.zToA': 'Z tot A',
  'aet.instructorCourse.manageRoster.column.name': 'Naam',
  'aet.instructorCourse.manageRoster.column.role': 'Rol',
  'aet.instructorCourse.manageRoster.column.email': 'Via e-mail',
  'aet.instructorCourse.manageRoster.column.access': 'eTextbook Access',
  'aet.instructorCourse.manageRoster.column.status': 'Status',
  'aet.instructorCourse.manageRoster.enrolledDate': 'Ingeschreven {date}',
  'aet.instructorCourse.manageRoster.enrolledLabel': 'Enrolled:',
  'aet.instructorCourse.manageRoster.changeTo': 'Change to:',
  'aet.instructorCourse.manageRoster.access.expired': 'Expired',
  'aet.instructorCourse.manageRoster.access.tempAccessDays': '{days}-day temp access',
  'aet.instructorCourse.manageRoster.notAvailable': '---',
  'aet.instructorCourse.manageRoster.access.active': 'Active',
  'aet.instructorCourse.manageRoster.access.inactive': 'Inactive',
  'aet.instructorCourse.manageRoster.access.tempAccess': 'Temporary',
  'aet.instructorCourse.roster.role.student': 'Student',
  'aet.instructorCourse.roster.role.ta': 'LA',
  'aet.instructorCourse.roster.role.instructor': 'Instructeur',
  'aet.instructorCourse.roster.status.active': 'Actief',
  'aet.instructorCourse.roster.status.inactive': 'Inactief',
  'aet.instructorCourse.manageRoster.filter.allMembers': 'Alle leden',
  'aet.instructorCourse.manageRoster.filter.activeStudents': 'Actieve studenten',
  'aet.instructorCourse.manageRoster.filter.inactiveStudents': 'Inactieve studenten',
  'aet.instructorCourse.manageRoster.filter.teachingAssistant': 'Lesassistent',
  'aet.instructorCourse.manageRoster.filter.instructor': 'Instructeur',
  'aet.instructorCourse.courseForm.materialsAuthorLabel': 'Auteur:',
  'aet.instructorCourse.courseForm.materialsIsbnLabel': 'ISBN:',
  'aet.instructorCourse.courseForm.materialsCreationDateLabel': 'Aanmaakdatum van cursus:',
  'aet.instructorCourse.noCoursesFound': 'Geen cursussen gevonden',
  'aet.instructorCourse.backButton': 'Terug',
  'aet.instructorCourse.selectCourse': 'Cursus selecteren',
  'aet.home.linkedToLms': 'Gekoppeld aan LMS',
  'aet.instructorCourse.courseForm.title.create': 'Cursus aanmaken',
  'aet.instructorCourse.courseForm.title.copy': 'Cursus kopiëren',
  'aet.instructorCourse.courseForm.title.edit': 'Cursusinformatie',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.title': 'Opdrachten',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.content': 'Inhoud van opdracht',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.dueDates': 'Deadline van opdrachten',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.title': 'Hoogtepunten en notities',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.highlightColor': 'Kleur van hoogtepunten',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.noteText': 'Notitietekst',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.sharedStatus': 'Gedeelde status',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.title': 'Rooster voor studenten en betrokkenheid',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.studentNames': 'Namen van studenten',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.emailAddresses': 'E-mailadres',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.enrollments': 'Inschrijvingen',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.completionAndInsights': 'Voltooiing en inzichten',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.title': 'Instellingen',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.aiToolEnablement': 'AI Tool enablement',
  'aet.instructorCourse.courseForm.copyAccordionTitle': 'Show what’s copied',
  'aet.instructorCourse.courseForm.copyAccordionSubTitle': 'Gekopieerde gegevens',
  'aet.studentRoster.manageStudentRosterButton': 'Rooster voor studenten beheren',
  'aet.studentRoster.dontHaveAnyStudent': 'Looks like you don’t have any students.',
  'aet.studentRoster.lmsEmptyState.title': 'No students have accessed the course yet',
  'aet.studentRoster.lmsEmptyState.description': 'As soon as students click through from your LMS, you’ll see their names and progress here.',
  'aet.studentRoster.nonlmsEmptyState.description': 'As soon as students join your course, you’ll see their names and progress here.',
  'aet.syllabus.editContentDisabledTooltip': 'Cannot update assignment while student work is in progress.',
  'aet.assignments.exportStudentProgressButton': 'Voortgang van studenten exporteren',
  'aet.home.student.roaster.enrolmentInformationTitle': 'Enrolment information',
  'aet.home.student.roaster.enrolmentInformation.status': 'Status:',
  'aet.home.student.roaster.enrolmentInformation.enrolled': 'Ingeschreven:',
  'aet.home.student.roaster.enrolmentInformation.access': 'Access:',
  'aet.home.student.roaster.enrolmentInformation.role': 'Rol:',
  'aet.home.student.roaster.enrolmentInformation.promotionCardTitle': '{studentName} promoten?',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent1': 'Als lesassistent kan deze persoon de voortgang en prestaties van alle studenten in deze les bekijken.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent2': 'Hij/zijn kan ook studenten en opdrachten beheren maar kan de les niet verwijderen.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardConfirmLabel': 'Promoten tot lesassistent',
  'aet.home.manageRoster.searchPlaceholder': 'Student zoeken',
  'aet.home.manageRoster.inactivateButtonLabel': 'Inactieve geselecteerde studenten',
  'aet.home.manageRoster.FilterLabel': 'Show',
  'aet.home.manageRoster.updatingMessage': 'Rooster bijwerken ... Dit kan enkele minuten duren.',
  'aet.home.courses.search.searchPlaceHolder': 'Zoek uw cursussen',
  'aet.courses.emptyStateDescription': 'Begin uw cursus samen te stellen door hieronder een optie te kiezen.',
  'nativePromoBanner.continueInBrowser': '.',
  'globalnav.tooltip.hideNavText': '.',
  'globalnav.tooltip.showNavText': '.',
  'aet.syllabus.progressTitle': 'Bezig met uitpakken...',
  'aet.syllabus.progressDesc': 'Een moment geduld, we verwerken uw syllabus.',
  'aet.syllabus.uploadInputLabel': 'Sleep bestanden hier naartoe of klik om ze te uploaden',
  'aet.syllabus.uploadSyllabusTabLabel': 'Syllabus uploaden',
  'aet.syllabus.dateAdjusterTabLabel': 'Datum aangepast',
  'aet.syllabus.addManuallyTabLabel': 'Opdrachten handmatig toevoegen',
  'aet.syllabus.addEditLaterText': 'U kunt opdrachten later altijd toevoegen en bewerken',
  'aet.syllabus.editAssignmentLabel': 'Opdracht bewerken',
  'aet.syllabus.addAssignmentLabel': 'Opdracht toevoegen',
  'aet.syllabus.assignmentTitleLabel': 'Titel van opdracht',
  'aet.syllabus.assignmentTitleAutoPlaceholder': 'Automatically generated',
  'aet.syllabus.dueDateLabel': 'Inleverdatum',
  'aet.syllabus.editDueDateLabel': '.',
  'aet.syllabus.chaptersCoveredLabel': 'Selecteer de hoofdstukken of onderdelen die u wilt behandelen.',
  'aet.syllabus.updateCtaLabel': 'Opdracht bijwerken',
  'aet.syllabus.addCtaLabel': 'Opdracht toevoegen',
  'aet.syllabus.uploadLabel': 'Uploaden',
  'aet.syllabus.confirmLabel': 'Bevestigen',
  'aet.syllabus.addContentLabel': 'Inhoud toevoegen',
  'aet.syllabus.addEditContentLabel': 'Inhoud toevoegen/bewerken',
  'aet.syllabus.notPublishedLabel': 'Niet gepubliceerd',
  'aet.syllabus.updateDatesLabel': 'Datum bijwerken',
  'aet.syllabus.dateNormalization.yearAdjustedContentSingle': 'Uw deadline is bijgewerkt. Controleer en publiceer vervolgens.',
  'aet.syllabus.coverageDedupe.adjustedContent': 'De gegevens van uw hoofdstuk/onderdeel zijn bijgewerkt. Controleer en publiceer vervolgens.',
  'aet.syllabus.unassignedCoverageStatus': 'Sommige hoofdstukken zijn nog niet toegewezen. Wijs ze toe voordat u publiceert.',
  'aet.syllabus.dateNormalization.manualEntryContent': 'Add a due date before you publish.',
  'aet.syllabus.pastDuePublishStatus': 'Update due date before you publish.',
  'aet.deleteAssignmentTitle': 'Opdracht verwijderen',
  'aet.deleteAssignmentTitleMultiple': 'Opdrachten verwijderen?',
  'aet.deleteAssignmentWarning': 'Dit kan niet ongedaan gemaakt worden, en bijbehorende inzendingen en gegevens van studenten zullen niet meer zichtbaar zijn.',
  'aet.deleteAssignmentKeepCTA': 'Opdracht behouden',
  'aet.deleteAssignmentDeleteCTA': 'VERWIJDEREN',
  'aet.assignments.loadingAsset': 'Bedrijfsmiddel laden…',
  'aet.assignments.addToDate': 'Toevoegen aan datum',
  'aet.assignments.previewAsStudent': 'Voorbeeld als student',
  'aet.assignments.questionsAndTopics': 'Vragen en onderwerpen',
  'aet.assignments.questionsAndTopicsModal.doneLabel': 'Klaar',
  'aet.assignments.questionsAndTopicsModal.dueDateLabel': 'Inleverdatum',
  'aet.assignments.questionsAndTopicsModal.questionsTotalLabel': 'Totaalaantal vragen',
  'aet.assignments.questionsAndTopicsModal.questionOfTotalLabel': 'Vraag {count} van {total}',
  'aet.assignments.publishToStudents': 'Publiceren voor studenten',
  'aet.assignments.availableToStudentsOn': 'Available to students on {0}',
  'aet.syllabus.addDateLabel': 'Datum toevoegen',
  'aet.doneLabel': 'Klaar',
  'aet.assignments.dueDateLabel': 'Deadline van opdracht',
  'aet.assignmentNameLabel': 'Assignment name',
  'aet.assignment.nameDisabledPlaceholder': 'Add content to generate a default name for your assignment',
  'aet.assignment.nameGeneratedPlaceholder': 'Automatically generated assignment name based on selected content',
  'aet.onboarding.getStarted.title': 'Get started creating assignments now',
  'aet.onboarding.getStarted.manualSetup.title': 'Handmatig aanmaken',
  'aet.onboarding.getStarted.manualSetup.description': 'Create and customize individual reading assignments and set their due dates',
  'aet.onboarding.getStarted.assistedScheduling.title': 'Assisted scheduling',
  'aet.onboarding.getStarted.assistedScheduling.description': 'Automatically set all due dates and easily add chapter content from your eTextbook',
  'aet.onboarding.getStarted.autoCreateAssignments.title': 'Auto-create assignments',
  'aet.onboarding.getStarted.autoCreateAssignments.description': 'Upload your syllabus to generate all reading assignments in seconds',
  'aet.onboarding.promotion.title': 'Hold students accountable with assigned reading',
  'aet.onboarding.promotion.feature.1': 'Create multiple assignments within minutes, with optional grade sync to your LMS',
  'aet.onboarding.promotion.feature.2': 'Gebruik realtime inzichten om leerachterstanden op te sporen, zodat u tijdig en met vertrouwen kunt ingrijpen',
  'aet.onboarding.promotion.feature.3': 'Studenten krijgen meer ondersteuning met gerichte feedback en de ingebouwde AI van Pearson',
  'aet.assistedSchedule.pageTitle': 'Assisted scheduling',
  'aet.assistedSchedule.reviewPageTitle': 'Create your assignments',
  'aet.assistedSchedule.sectionTitle': 'Set a recurring assignment schedule',
  'aet.assistedSchedule.sectionDescription': 'We\'ll create assignment slots throughout your course that you can populate with content from your eTextbook.',
  'aet.assistedSchedule.dueDaysLabel': 'Due day(s)',
  'aet.assistedSchedule.dueDaysTip': 'Tip: Make assignments due 1 or 2 days before your class meets in order to get the most out of assignment insights',
  'aet.assistedSchedule.dueDaysPlaceholder': 'Choose',
  'aet.assistedSchedule.dueDaysRequiredError': 'Select at least one day',
  'aet.assistedSchedule.dueTimeRequiredError': 'Due time is required',
  'aet.assistedSchedule.timeZoneRequiredError': 'Time zone is required',
  'aet.assistedSchedule.startDateLabel': 'Starts on',
  'aet.assistedSchedule.endDateLabel': 'Ends on',
  'aet.assistedSchedule.datePlaceholder': 'mm/dd/yyyy',
  'aet.assistedSchedule.startDateRequiredError': 'Start date is required',
  'aet.assistedSchedule.endDateRequiredError': 'End date is required',
  'aet.assistedSchedule.scheduleInstruction': 'Drag content into the assignment slots to build your schedule.',
  'aet.assistedSchedule.dragZoneLabel': 'Drag content here to assign it to students',
  'aet.assistedSchedule.clickToEditLabel': 'Click to edit',
  'aet.assistedSchedule.clearDataLabel': 'Clear data',
  'aet.assistedSchedule.formValidationLiveRegion': 'Form has validation errors',
  'aet.assistedSchedule.noQuestionsError': 'Each assignment must include content with at least one question.',
  'aet.assistedSchedule.noQuestionsWarningLabel': 'Add content with at least 1 question to save this assignment.',
  'aet.assistedSchedule.noAssignmentsModalTitle': 'No assignments can be created',
  'aet.assistedSchedule.noAssignmentsModalMessage': 'The selected date range is too short to generate any assignments. Extend the date range and try again.',
  'aet.assignments.allCaughtUpDescription': 'Er zijn geen opdrachten die deze week af moeten.',
  'aet.assignments.progressTitle': 'Voortgang',
  'aet.assignments.performanceTitle': 'Vertrouwen',
  'aet.assignments.completionTitle': 'Voltooiing',
  'aet.assignments.statusTitle': 'Status',
  'aet.assignments.addTooltip': 'Opdracht toevoegen',
  'aet.assignments.deleteTooltip': 'Geselecteerde opdrachten verwijderen',
  'aet.assignments.selectToDeleteLabel': 'Modus selecteren en verwijderen',
  'aet.assignments.bulkEditTooltip': 'Meerdere opdrachten tegelijk bewerken',
  'aet.assignments.title': 'Opdrachten',
  'aet.assignments.assignmentTitle': 'Opdracht',
  'aet.assignments.dueDate': 'Inleverdatum',
  'aet.tabular.searchPlaceholder.assignments': '.',
  'aet.tabular.searchPlaceholder.students': '.',
  'aet.tabular.searchPlaceholder.questions': '.',
  'aet.assignemnts.columnDueDateInfoTooltip': '.',
  'aet.assignemnts.singleDueDateInfoTooltip': '.',
  'aet.assignemnts.masterDueDateInfoTooltip': '.',
  'aet.home.loading': 'Bezig met laden...',
  'aet.home.errorFetchingAssignments': 'Fout bij het ophalen van opdrachten',
  'aet.home.dueThisWeekTitle': 'Moet deze week af zijn',
  'aet.home.allCaughtUpTitle': 'U bent helemaal bij!',
  'aet.home.allCaughtUpDescription': 'Er zijn geen opdrachten die deze week af moeten.',
  'aet.home.suggestedRemediationTitle': '.',
  'aet.home.noSuggestedRemediationTitle': 'Geen aanbevolen beoordelingsmateriaal',
  'aet.home.noSuggestedRemediationDescription': 'Probeer het nog eens na uw volgende opdracht.',
  'aet.home.assignmentIncludesTitle': 'Opdracht bevat',
  'aet.home.sectionsLabel': '.',
  'aet.home.questionsCount': '{count} vragen',
  'aet.home.dueLabel': '.',
  'aet.home.due': 'Moet af zijn:',
  'aet.home.progressCompletedLabel': 'Voltooid',
  'aet.home.progressCompletedPastDueLabel': 'Te laat voltooid',
  'aet.home.progressInProgressLabel': 'In behandeling',
  'aet.home.progressPartiallyCompleteLabel': 'Partially complete',
  'aet.home.progressNotStartedLabel': 'Nog niet begonnen',
  'aet.home.progressCountOfTotal': '.',
  'aet.home.NotAttemptedLabel': 'Niet geprobeerd',
  'aet.home.questionsTotalLabel': 'Totaalaantal vragen',
  'aet.home.progressCompletedOnTimeLabel': 'Op tijd afgerond',
  'aet.home.segmentGreatLabel': 'Super',
  'aet.home.segmentGettingThereLabel': 'OK',
  'aet.home.segmentNeedsReviewLabel': 'Kan beter',
  'aet.home.segmentOkayLabel': 'OK',
  'aet.home.editAssignmentTooltip': 'Opdracht bewerken',
  'aet.home.deleteAssignmentTooltip': 'Opdracht verwijderen',
  'aet.home.viewDetailsButton': 'Details weergeven',
  'aet.home.viewAsStudentButton': 'Bekijken als student',
  'aet.home.welcomeButtonText': 'Beginnen →',
  'aet.review.emptyStateTitle': 'Niets te beoordelen',
  'aet.review.emptyStateDescription': 'Probeer het nog eens na uw volgende opdracht.',
  'aet.dashboard.tabs.upNext': 'Volgende',
  'aet.dashboard.tabs.welcome': 'Welkom',
  'aet.dashboard.tabs.assignments': 'Opdrachten',
  'aet.dashboard.tabs.review': 'Beoordelen',
  'aet.dashboard.tabs.studentRoster': 'Studenten',
  'aet.dashboard.classSchedule': 'Leschema:',
  'aet.syllabus.dueTimeLabel': 'Inlevertijd',
  'hero.accessEducatorGuides': 'Maak gebruik van gidsen voor onderwijzers',
  'aet.assignment.save': 'Opslaan',
  'aet.assignment.finish': 'Afronden',
  'aet.assignment.saveAndAdd': 'Nog een opslaan en sluiten',
  'aet.assignment.delete': 'VERWIJDEREN',
  'aet.assignment.saveAndClose': 'Opslaan en sluiten',
  'aet.studentRoster.title': 'Studenten',
  'aet.studentRoster.titlev1': 'Student',
  'aet.studentRoster.dueDatesAdjustmentLabel': '.',
  'aet.studentRoster.dueDateAdjustment.option.0': 'Standaard',
  'aet.studentRoster.dueDateAdjustment.option.2': '.',
  'aet.studentRoster.dueDateAdjustment.option.3': '.',
  'aet.studentRoster.dueDateAdjustment.option.5': '.',
  'aet.studentRoster.dueDateAdjustment.option.week.1': '.',
  'aet.studentRoster.dueDateAdjustment.option.week.2': '.',
  'aet.studentRoster.dueDateAdjustment.option.lastDayOfClass': '.',
  'aet.studentRoster.dueDateAdjustment.toast.partial.title.multiple': '.',
  'aet.studentRoster.dueDateAdjustment.toast.partial.message': '.',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.title': '.',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.message': '.',
  'aet.bulkEdit.bulkSplitInstruction': 'We zullen uw opdrachten gelijkmatig verdelen.',
  'aet.bulkEdit.Description': '.',
  'aet.bulkEdit.firstAssignmentDue': 'Deadline eerste opdracht',
  'aet.bulkEdit.lastAssignmentDue': 'Deadline laatste opdracht',
  'aet.bulkEdit.assignmentsDueDays': 'Welke dagen wilt u voor de deadline van uw opdrachten?',
  'aet.bulkEdit.addEditLaterText': 'We maken opdrachten met AI. U kunt ze later altijd bewerken.',
  'aet.bulkEdit.monday': 'Maandag',
  'aet.bulkEdit.tuesday': 'Dinsdag',
  'aet.bulkEdit.wednesday': 'Woensdag',
  'aet.bulkEdit.thursday': 'Donderdag',
  'aet.bulkEdit.friday': 'Vrijdag',
  'aet.bulkEdit.saturday': 'Zaterdag',
  'aet.bulkEdit.sunday': 'Zondag',
  'aet.toast.assignmentCreated.title': 'Opdracht aangemaakt!',
  'aet.toast.assignmentCreated.single': 'Automatisch is de naam {assignmentTitle} toegekend',
  'aet.toast.assignmentCreated.multiple': '{count} opdrachten zijn aangemaakt',
  'aet.toast.assignmentUpdated.title': '.',
  'aet.toast.assignmentUpdated.single': '{assignmentTitle} is bijgewerkt',
  'aet.toast.assignmentUpdated.multiple': '.',
  'aet.toast.assignmentPublished.single': '{count} assignment successfully published!',
  'aet.toast.assignmentPublished.multiple': '{count} assignments successfully published!',
  'aet.toast.assignmentPublished.subtitle': 'De inhoud van de opdracht kan aangepast worden tot studenten beginnen werken.',
  'aet.toast.viewAssignment': 'Opdracht weergeven',
  'aet.toast.viewAssignments': 'Opdracht weergeven',
  'aet.welcome.title': 'Uw eTextbook van Pearson is nu gekoppeld aan uw LMS-cursus',
  'aet.welcome.LMSAccounTitle': 'Inzicht verwerven',
  'aet.welcome.LMSAccounDescription': 'Bekijk precies welke onderwerpen uw klas lastig vindt.',
  'aet.welcome.createAssignmentsTitle': 'Opdrachten aanmaken',
  'aet.welcome.createAssignmentsDescription': 'Wijs hoofdstukken handmatig toe of upload uw syllabus.',
  'aet.welcome.progressViewTitle': 'Houd uw prestaties bij in uw LMS',
  'aet.welcome.progressViewDescription': 'Kies de synchronisatie-instellingen van uw resultaat in uw LMS-cursus.',
  'aet.assignmentDetails.noAssignmentFound': 'Geen opdracht gevonden',
  'aet.assignments.loadingErrorTitle': 'Opdracht kan nu niet geladen worden',
  'aet.assignments.loadingErrorDescription': 'Vernieuw ze of probeer het lager nog eens.',
  'aet.assignmentStudentDetails.noDataFound': 'Nog geen gegevens',
  'aet.assignmentStudentDetails.noData': 'No data',
  'aet.studentRoster.noStudentsRegisteredYet': 'Geen geregistreerde studenten',
  'aet.studentRoster.noStudentsRegisteredYetDescription': 'Studenten registreren zich voor uw klas als ze het eTextbook aanschaffen.',
  'aet.home.editAssignmentTooltipDisabled': 'Kan niet aanpassen: student werkt eraan',
  'aet.home.deleteAssignmentTooltipDisabled': 'Kan niet verwijderen: student werkt eraan',
  'aet.home.StudentDetails.questions': 'Vragen',
  'aet.home.StudentDetails.attempts': 'Pogingen',
  'aet.home.StudentDetails.comprehension': 'Vertrouwen',
  'hero.titleInfo.tooltip': 'Titelinformatie',
  'aet.home.publishAssignments': 'Alle opdrachten publiceren',
  'aet.assignments.saveScheduleAsDraft': 'Planning opslaan als concept',
  'aet.assignments.reviewBeforePublishAlert': 'Controleer uw opdrachten en publiceer ze vervolgens om ze zichtbaar te maken voor studenten.',
  'aet.assignments.copiedCoursePublishAlert': 'Voeg datums toe aan uw gekopieerde opdrachten en publiceer ze om ze zichtbaar te maken voor studenten.',
  'aet.assignments.allSetPublishAlert': 'Helemaal klaar? Publiceer uw opdrachten om ze zichtbaar te maken voor studenten.',
  'aet.assignments.emptyStateTitle': 'No assignments yet',
  'aet.assignments.emptyStateDescription': 'Assignments you create will appear here',
  'aet.dashboard.footer': 'Bepaalde inhoud is met AI gemaakt op basis van de leermaterialen van Pearson. Pearson controleert de gegenereerde inhoud, want AI kan onjuiste informatie genereren over personen, locaties of feiten.',
  'aet.home.bulkEditTitle': 'Meerdere opdrachten tegelijk bewerken',
  'aet.home.bulkEditSubtitle': 'Breng wijzigingen aan uw syllabus aan en upload deze daar opnieuw. Uw opdrachten en inleverdata worden daarop afgestemd.',
  'aet.home.createAssignmentTitle': 'Opdrachten aanmaken',
  'aet.assignments.includedInAnotherAssignmentTooltip': 'Behorend tot een andere opdracht',
  'aet.assignments.someSectionsIncludedInAnotherAssignmentTooltip': 'Sommige onderdelen behoren tot een andere opdracht',
  'aet.welcome.welcome.Title': 'Welkom!',
  'aet.home.student.roaster.ProgressTitle': 'Totale voltooiing',
  'aet.assignmentStudentDetails.startAssignmentDescription': 'Kom terug als studenten beginnen aan de opdracht.',
  'aet.home.whatDueThisWeekTitle': 'Dit is wat deze week af moet',
  'aet.assignments.edit.errorTitle': '{count} opdrachten met fouten',
  'aet.assignments.edit.errorSubTitle': 'Opdrachten met fouten kunnen niet gepubliceerd worden. Bewerk ze of publiceer ze zonder.',
  'aet.assignments.edit.publishAnyway': 'Toch publiceren',
  'aet.assignments.edit.editAssignments': 'Opdrachten bewerken',
  'aet.assignments.edit.validationInfoToolTip': 'Opdracht bewerken om fouten te verwijderen',
  'aet.assignments.error.assignmentCreated.title': 'Er zijn fouten in alle opdrachten',
  'aet.assignments.error.assignmentCreated.description': 'Opdrachten met fouten kunnen niet gepubliceerd worden. Bewerk ze of probeer een andere syllabus.',
  'aet.assignments.error.uploadSyllabus': 'Syllabus uploaden',
  'aet.assignments.error.editAssignments': 'Opdrachten bewerken',
  'aet.mondly.title': 'Talen',
  'aet.studentRoster.errorState.title': 'Studentlijst niet beschikbaar',
  'aet.studentRoster.errorState.description': 'We konden je studentenlijst niet laden. Vernieuw ze of probeer het lager nog eens.',
  'aet.assignments.sectionLabel': 'onderdeel/onderdelen',
  'aet.assignments.sectionLabelCapitalized': 'Section(s):',
  'aet.assignments.sectionsPrefix': 'Sections:',
  'aet.assignments.chaptersPrefix': 'Chapters:',
  'aet.assignments.questionsLabel': 'vraag/vragen',
  'aet.assignments.assignmentsLabel': 'opdracht(en)',
  'aet.assignments.performanceProgressBar': 'Voortgangsbalk prestaties',
  'aet.assignments.completionProgressBar': 'Voortgangsbalk voltooiing',
  'aet.syllabus.deleteConfirmationSubtitleSingle': 'Weet u zeker dat u deze opdracht wilt verwijderen?',
  'aet.syllabus.deleteConfirmationSubtitleBulk': 'Weet u zeker dat u deze opdrachten wilt verwijderen?',
  'aet.home.nextAssignmentTitle': 'Volgende opdracht',
  'aet.home.courseSettings': 'Instellingen cursus',
  'aet.home.assignmentSettings': 'Assignment settings',
  'aet.home.pearsonETextbookResources': 'Pearson+ eTextbook-hulpmiddelen',
  'aet.home.etextbookInformation': 'Gegevens eTextbook',
  'aet.multiple.deleteAssignmentKeepCTA': 'Opdracht(en) behouden',
  'aet.syllabus.processingText.header': 'We ordenen de teksten die aan uw klas zijn toegevoegd. Dit duurt niet lang.',
  'aet.syllabus.processingText.uploading': 'Uw document wordt geüpload',
  'aet.syllabus.processingText.activating': 'AI-componenten activeren',
  'aet.syllabus.processingText.extracting': 'Bezig met uitpakken van leesopdrachten',
  'aet.syllabus.processingText.mapping': 'Bezig met koppelen aan inhoud tekstboek',
  'aet.syllabus.processingText.finishing': 'Bezig met afronden',
  'aet.syllabus.uploadErrorMessage': 'Controleer of uw pdf-bestand kleiner is dan 10 MB en dat uw internetverbinding stabiel is',
  'aet.syllabus.uploadNoAssignmentsMessage': 'Geen leesopdrachten gevonden',
  'aet.syllabus.uploadNoAssignmentsDescription': 'We konden geen leesopdrachten uit dit bestand halen. U kunt ze handmatig toevoegen.',
  'aet.syllabus.uploadFailedRetryCTA': 'Probeer het opnieuw',
  'aet.syllabus.uploadModal.noAssignments.title': 'Couldn\'t find assignments',
  'aet.syllabus.uploadModal.noAssignments.body1': 'We weren\'t able to find any reading assignments within the uploaded syllabus.',
  'aet.syllabus.uploadModal.noAssignments.body2': 'Controleer of uw syllabus de <qualities a syllabus should have for this to work> heeft en probeer het opnieuw. U kunt de opdracht ook handmatig aanmaken.',
  'aet.syllabus.uploadModal.noAssignments.manualCreationCTA': 'Handmatige aanmaak',
  'aet.syllabus.uploadModal.noAssignments.backToUploadCTA': 'Back to upload',
  'aet.syllabus.uploadModal.genericFailure.title': 'Er is iets misgegaan',
  'aet.syllabus.uploadModal.genericFailure.body1': 'We konden de syllabus niet uploaden en verwerken.',
  'aet.syllabus.uploadModal.genericFailure.body2': 'Controleer uw internetverbinding en probeer het opnieuw of maak de opdracht handmatig aan.',
  'aet.syllabus.uploadModal.successTotal.title': 'Klaar om te beoordelen',
  'aet.syllabus.uploadModal.successTotal.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successTotal.body2': 'Make any adjustments, then save or publish when you\'re ready. You can continue making changes before students start working.',
  'aet.syllabus.uploadModal.successPartial.title': 'Klaar om te beoordelen',
  'aet.syllabus.uploadModal.successPartial.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successPartial.body2': 'We couldn\'t find exact matches in the eTextbook for every item. Review your assignments to make any adjustments, then save or publish when you\'re ready.',
  'aet.syllabus.uploadModal.reviewAssignmentsCTA': 'Opdrachten controleren',
  'aet.syllabus.selectChapterWithQuestions': 'Selecteer een hoofdstuk met een of meerdere vragen',
  'preferenceSetting.subTitle': 'Deze instellingen zijn standaard voor alle deelnemers aan deze cursus.',
  'preferenceSetting.sections.isAIStudyEnabled.label': 'AI-interacties',
  'preferenceSetting.sections.isAIStudyEnabled.subLabel': 'Studeren met AI en AI-samenvattingen inschakelen in zoekresultaten',
  'preferenceSetting.sections.isStudyPrepEnabled.subLabel': 'Hulpmiddelen voor studievoorbereiding bij dit boek weergeven',
  'aet.syllabus.footer': 'Opdrachten worden met AI gemaakt',
  'aet.dashboard.footerDialogDeatils': 'De vragen van de opdracht worden met generatieve AI gemaakt op basis van de leermaterialen van Pearson. Pearson controleert de gegenereerde inhoud, want AI kan onjuiste informatie genereren over personen, locaties of feiten. AI wordt ook gebruikt om inhoud te groeperen in opdrachten, op basis van de syllabus en/of het schema dat u verstrekt.',
  'aet.review.footer': 'Gemaakt met AI',
  'aet.footerCard.dismiss': 'Afwijzen',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText1': 'Studievoorbereiding is een aanvullende tool waarmee studenten leren aan de hand van video\'s en praktijkoefeningen speciaal voor deze cursus.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText2': 'Studenten die geen toegang hebben tot Studievoorbereiding kunnen de vraag krijgen een abonnement te nemen om door te kunnen gaan met de bronnen van Studievoorbereiding.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText3': 'Studenten die Studievoorbereiding al hebben gekocht, merken hier niets van.',
  'preferenceSetting.sections.isStudyPrepEnabled.helpLinkText': 'Meer informatie over de voordelen van Studievoorbereiding',
  'aet.home.viewCourseId': 'Cursusnummer weergeven',
  'aet.home.copy': 'Kopiëren',
  'aet.home.copied': 'Gekopieerd',
  'aet.home.courseLabel': 'Cursusnummer:',
  'schoolInfoCard.addUniversity': '.',
  'schoolInfoCard.title': 'Gegevens school',
  'schoolInfoCard.titleV1': 'Vertel ons meer over uw cursus',
  'schoolInfoCard.cta': 'Beginnen',
  'schoolInfoCard.pickInstitution': '.',
  'schoolInfoCard.addUniversityTitle': 'Voeg uw school toe',
  'schoolInfoCard.addUniversitySubtitle': 'Als u weet welke school en cursus het betreft, kunnen we u de meest nuttige studiematerialen aanbevelen.',
  'schoolInfoCard.searchPlaceholder': 'Zoek uw school...',
  'schoolInfoCard.skip': 'Deze stap overslaan',
  'schoolInfoCard.nextStep': 'Volgende stap',
  'schoolInfoCard.notInList': 'Mijn school staat er niet tussen',
  'schoolInfoCard.noResults': 'Geen scholen komen overeen met uw zoekopdracht',
  'schoolInfoCard.noResultsHeading': 'Kunt u uw school niet vinden?',
  'schoolInfoCard.noResultsInstruction': 'Voer de volledige naam hieronder in',
  'schoolInfoCard.noResultsInputPlaceholder': 'Naam van de school',
  'schoolInfoCard.addInstitutionLabel': 'Deze school toevoegen',
  'aet.assignments.assignmentTitlePlaceholder': 'Voer een titel in',
  'aet.assignments.titleValidation.titleRequired': 'Titel van de opdracht is vereist.',
  'aet.assignments.titleValidation.titleTooLong': 'Titel van de opdracht mag niet meer dan {0} tekens zijn.',
  'aet.assignments.titleValidation.titleInvalidChar': 'Titel van de opdracht bevat niet-ondersteunde tekens.',
  'aet.assignments.titleValidation.titleDuplicate': 'Titel van de opdracht bestaat al',
  'aet.syllabus.timeZoneLabel': 'Tijdzone',
  'aet.review.reviewReadingFromAssignments': 'Beoordeling lezen van opdracht',
  'aet.assignments.chaptersLabel': '.',
  'menu.myAccount.subTitle': '.',
  'menu.myAccount.subTitleNotAvailable': '.',
  'schoolInfoCard.toastMessage': '.',
  'aet.review.threeDotMenu.askAI': 'Vraag AI',
  'aet.home.suggestedRemediationSubtitle': '.',
  'aet.home.laggedQuestionLabel': 'Gemarkeerde vragen',
  'aet.home.correctAnswer': 'Juist antwoord',
  'aet.home.incorrectAnswer': 'Het meest gegeven onjuiste antwoord',
  'aet.home.behaviourTrendsLabel': 'Inzichten in vragen',
  'aet.home.strugglingStudentsLabel': 'Studenten die het moeilijk hebben',
  'aet.home.patternsInStudensAiLabel': 'Patronen in het gebruik van AI door studenten',
  'aet.home.questionLabel': 'Vraag',
  'aet.home.studentAskingSimilarQuestions': 'Studenten die vergelijkbare vragen stellen',
  'aet.home.assignmentDifficultQuestions': 'Moeilijke vragen',
  'aet.home.behaviorTrends': 'Inzichten in vragen',
  'aet.home.behaviors': 'Prestatie-indicatoren',
  'aet.home.mostDifficultTopics': '.',
  'aet.home.commentsFromStudentLabel': 'Opmerkingen van studenten',
  'aet.home.disregard': 'Negeren',
  'aet.home.reportAsInaccurate': 'Melden als onnauwkeurig',
  'aet.home.Flagged': 'Gemarkeerd',
  'aet.home.reportQuestionTitle': 'Vraag markeren',
  'aet.home.reportQuestionLabel': 'Wat was er niet goed aan deze vraag?',
  'aet.home.showComments': 'Opmerkingen tonen',
  'aet.home.studentReports': 'rapporten van studenten',
  'aet.home.placeholderText': 'Leg uit...',
  'aet.home.reportQuestion.notRelevant': 'Niet relevant',
  'aet.home.reportQuestion.notCorrect': 'Onjuist',
  'aet.home.reportQuestion.unsafe': '.',
  'aet.home.reportQuestion.somethingElse': 'Iets anders',
  'aet.home.StudentDetails.assistedByAI': 'Ondersteund door AI',
  'aet.home.strugglingStudents.emptyStateTitle': 'Er zijn op dit moment geen studenten die het moeilijk hebben',
  'aet.home.strugglingStudents.emptyStateDescription': 'Probeer het lager nog eens.',
  'aet.home.overallStatus.excelling': 'Uitblinkend',
  'aet.home.overallStatus.fallingBehind': 'Loopt achter',
  'aet.home.overallStatus.keepingUp': '.',
  'aet.home.showOnlyDifficultQuestionsLabel': '.',
  'aet.home.showOnlyStrugglingStudentsLabel': '.',
  'aet.home.viewQuestionInAssignment': '.',
  'aet.home.insightRisk.incorrectFirstAttempts': '.',
  'aet.home.insightRisk.multipleIncorrectAttempts': '.',
  'aet.home.insightRisk.lowConfidence': '.',
  'aet.home.insightRisk.mediumConfidence': '.',
  'aet.home.insightRisk.lowEngagement': '.',
  'aet.home.insightRisk.countOfStudents': '.',
  'aet.home.insightRisk.na': 'N.v.t.',
  'aet.home.strugglingStudentsHereLabel': '.',
  'aet.home.insightRisk.didNotAttempt': '.',
  'aet.home.insightRisk.attempted': 'Attempted',
  'aet.courseHeader.assignableEText': 'Assignable eText',
  'aet.courseHeader.lmsIntegration': 'LMS-integratie',
  'aet.courseHeader.lmsIntegrationSubLabel': 'Connected to your LMS',
  'aet.instructorCourse.courseForm.institutionNotOfferedError': 'This institution does not offer this product.'
};

export default nl;
